import { useMediaQuery } from 'react-responsive';
import { theme } from '@fiverr-private/theme';

export const useBreakpointSm = () => useMediaQuery({ minWidth: theme.numericBreakpoints.sm });
export const useBreakpointMd = () => useMediaQuery({ minWidth: theme.numericBreakpoints.md });
export const useBreakpointLg = () => useMediaQuery({ minWidth: theme.numericBreakpoints.lg });
export const useBreakpointXl = () => useMediaQuery({ minWidth: theme.numericBreakpoints.xl });
export const useBreakpointXxl = () => useMediaQuery({ minWidth: theme.numericBreakpoints.xxl });
